import type { ReactNode } from 'react';
import { useQuery } from '@apollo/client';
import { Panel } from '@ics-portal/guardian';
import { ListableInfo } from '@ics-portal/guardian';
import { GET_SINGLE_COMPONENT_VENDOR } from '@api/queries/vendor';
import {
    vendorAssessmentResult,
    vendorAssessmentStatus,
    vendorAssessmentType,
} from './helpers/mappings';

interface VendorProps {
    componentId?: string | null;
}

export function VendorAssessment({ componentId }: VendorProps): ReactNode {
    const { data } = useQuery(GET_SINGLE_COMPONENT_VENDOR, {
        variables: { componentId },
    });

    if (!componentId) {
        return null;
    }

    const vendor = data?.components.edges[0]?.node.componentVendor;
    if (!vendor) {
        return null;
    }

    const assessments = vendor.assessments;

    return (
        <Panel header={`Vendor evaluation: ${vendor.name}`}>
            {assessments?.length ? (
                assessments.map((assessment) => {
                    return (
                        <div key={assessment.id}>
                            <div className="flex flex-column gap-2 pt-sm pb-lg">
                                <h4>
                                    Vendor type:{' '}
                                    {vendorAssessmentType(assessment.type)}
                                </h4>
                                <ListableInfo
                                    label="Assesment status"
                                    value={vendorAssessmentStatus(
                                        assessment.status,
                                    )}
                                    orientation="vertical"
                                />
                                <ListableInfo
                                    label="Assesment result"
                                    value={vendorAssessmentResult(
                                        assessment.result,
                                    )}
                                    orientation="vertical"
                                />
                            </div>
                        </div>
                    );
                })
            ) : (
                <p>No vendor type has been assigned to this vendor yet.</p>
            )}
        </Panel>
    );
}
